import { useSyncExternalStore } from 'react';

/**
 * A chave completa só aparece na criação. Fica só na memória da aba (nunca em storage),
 * para a aba MCP preencher os snippets enquanto a página não for recarregada.
 */
let atual: string | null = null;
const ouvintes = new Set<() => void>();

export function guardarChaveRecente(chave: string | null) {
  atual = chave;
  ouvintes.forEach((f) => f());
}

export function useChaveRecente(): string | null {
  return useSyncExternalStore(
    (f) => {
      ouvintes.add(f);
      return () => ouvintes.delete(f);
    },
    () => atual,
  );
}
